import React from 'react';
import { Award, Trophy, Globe, Crown, ShieldCheck, Sparkles, Compass, Star } from 'lucide-react';

const achievementsList = [
  {
    title: 'Guinness World Record Holder — LIC',
    icon: Globe,
  },
  {
    title: 'LIC Top Performer — Chennai Division I',
    icon: Crown,
  },
  {
    title: 'Centurion Policy Holder',
    icon: ShieldCheck,
  },
  {
    title: 'Distinguished Club Agent',
    icon: Sparkles,
  },
  {
    title: 'Zonal Convention Qualifier',
    icon: Compass,
  },
  {
    title: 'Star Performers Qualifier',
    icon: Star,
  },
];

const RecognitionSection = () => {
  return (
    <section className="testimonial-section-container" id="recognition">
      <div className="testimonial-content-wrapper">
        
        {/* Top Header */}
        <div className="testimonial-top-header">
          <div className="testimonial-badge">
            <Award size={14} className="badge-icon" />
            <span>Recognition</span>
          </div>
          <h2 className="testimonial-main-heading">
            RECOGNIZED FOR<br />EXCELLENCE IN INSURANCE
          </h2>
        </div>

        {/* 2-Column Content Grid */}
        <div className="testimonial-grid">
          
          {/* Left Dark Green Experience Card */}
          <div className="testimonial-rating-card recognition-left-card">
            <div className="rating-top">
              <h3 className="rating-big-number">23+ Years</h3>
              <h4 className="recognition-exp-title">Professional Experience</h4>
            </div>

            <p className="rating-card-desc">
              Dedicated expertise in insurance, risk management, and long-term financial planning.
            </p>

            <div className="recognition-trophy-badge">
              <Trophy size={24} className="trophy-icon" />
              <span>Proven Industry Leader</span>
            </div>
          </div>

          {/* Right Light Recognition & Achievements Card */}
          <div className="testimonial-card-main recognition-right-card">
            
            <h3 className="testimonial-headline">
              Professional Recognition &amp; Achievement
            </h3>

            <p className="testimonial-quote-text" style={{ marginBottom: '24px' }}>
              Recognized for consistent performance and professional excellence through
              achievements across LIC and industry platforms.
            </p>

            {/* Achievements Checklist Grid */}
            <div className="recognition-achievements-grid">
              {achievementsList.map((item, idx) => {
                const IconComponent = item.icon;
                return (
                  <div key={idx} className="recognition-achievement-item">
                    <IconComponent size={20} className="achievement-icon" />
                    <span className="achievement-text">{item.title}</span>
                  </div>
                );
              })}
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default RecognitionSection;
